import { render } from "./ConfigDialog.vue?vue&type=template&id=66f2a35e"
import script from "./ConfigDialog.vue?vue&type=script&lang=js"
export * from "./ConfigDialog.vue?vue&type=script&lang=js"

import "./ConfigDialog.vue?vue&type=style&index=0&id=66f2a35e&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__